module.exports = __webpack_public_path__ + "static/media/folder.2bbcb0e2.svg";